<template>
  <v-card class="helmi-card">
    <div class="helmi-card-title pl-6 pt-6">
      Muokkaa päivämääriä
    </div>
    <v-card-text class="pt-4 pb-0">
      <v-menu
        v-model="signDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template #activator="{ on }">
          <v-text-field
            v-model="signDateFormatted"
            outlined
            label="Kaupantekopäivä"
            append-icon="event"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="signDateModify"
          locale="fi-FI"
          first-day-of-week="1"
          @input="signDateMenu = false;"
        />
      </v-menu>
      <v-menu
        v-model="transferDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template #activator="{ on }">
          <v-text-field
            v-model="transferDateFormatted"
            outlined
            label="Omistusoikeuden siirtymispäivä"
            append-icon="event"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="transferDateModify"
          locale="fi-FI"
          first-day-of-week="1"
          @input="transferDateMenu = false;"
        />
      </v-menu>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="primary"
        text
        @click="closeDialog()"
      >
        Peruuta
      </v-btn>
      <v-btn
        color="primary"
        text
        :loading="sending"
        @click="saveTaxTransferDates()"
      >
        Tallenna
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import moment from 'moment';
import { apiPost } from '../../api';

export default {
  name: 'ModifyTaxTransferDates',
  props: {
    signDate: {
      type: Object,
      default: () => {},
    },
    transferDate: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    signDateMenu: false,
    transferDateMenu: false,
    sending: false,
    signDateModify: '',
    transferDateModify: '',
  }),
  computed: {
    signDateFormatted() {
      return moment(this.signDateModify, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },
    transferDateFormatted() {
      return moment(this.transferDateModify, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },
  },
  mounted() {
    this.signDateModify = new Date(`${moment(this.signDate, 'DD.MM.YYYY')} GMT`).toISOString().substr(0, 10);
    this.transferDateModify = new Date(`${moment(this.transferDate, 'DD.MM.YYYY')} GMT`).toISOString().substr(0, 10);
  },
  methods: {
    closeDialog() {
      this.$bus.$emit('closeTaxTransferDatesDialog');
    },
    async saveTaxTransferDates() {
      this.sending = true;
      const params = {
        signDate: this.signDateFormatted,
        transferDate: this.transferDateFormatted,
      };
      await apiPost(`properties/updatedates/${this.$route.params.propertyId}`, params);

      this.sending = false;
      this.$bus.$emit('closeTaxTransferDatesDialog');
      this.$bus.$emit('reload');
    },
  },
};
</script>
